module.exports = __webpack_public_path__ + "resources/icon_44_share_small.b88a064cab9ba8d2.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_share_small.png
// module id = 436
// module chunks = 0 1 2 3 4